import { Pipe, PipeTransform } from "@angular/core";
import { DatePipe } from "@angular/common";

@Pipe({
    name: "filterDateTime"
    ,pure: false
})
export class FilterDateTime implements PipeTransform {

    transform(inputValue:any,format:string):any {
        if(!inputValue){
            return inputValue;
        }
        if(!format){
            format = "yyyy-MM-dd HH:mm:ss";
        }

        try{
            let chkPattern = /^(?<year>\d{4})(?<month>\d{2})(?<day>\d{2})$/;
            if(chkPattern.test(inputValue)){
                let tmpDate = this.getDate(inputValue,chkPattern);
                return new DatePipe("en-US").transform(tmpDate,format);
            }

            chkPattern = /^(?<hour>\d{2})(?<minute>\d{2})(?<second>\d{2})$/;
            if(chkPattern.test(inputValue)){
                let tmpDate = this.getDate(inputValue,chkPattern);
                return new DatePipe("en-US").transform(tmpDate,format);
            }

            chkPattern = /^(?<year>\d{4})(?<month>\d{2})(?<day>\d{2})(?<hour>\d{2})(?<minute>\d{2})(?<second>\d{2})$/;
            if(chkPattern.test(inputValue)){
                let tmpDate = this.getDate(inputValue,chkPattern);
                return new DatePipe("en-US").transform(tmpDate,format);
            }

            chkPattern = /^(?<year>\d{4})(?<month>\d{2})(?<day>\d{2})[\sT]{1}(?<hour>\d{2})(?<minute>\d{2})(?<second>\d{2}).*$/;
            if(chkPattern.test(inputValue)){
                let tmpDate = this.getDate(inputValue,chkPattern);
                return new DatePipe("en-US").transform(tmpDate,format);
            }

            chkPattern = /^(?<year>\d{4})-(?<month>\d{2})-(?<day>\d{2})[\sT]{1}(?<hour>\d{2}):(?<minute>\d{2}):(?<second>\d{2}).*$/;
            if(chkPattern.test(inputValue)){
                let tmpDate = this.getDate(inputValue,chkPattern);
                return new DatePipe("en-US").transform(tmpDate,format);
            }

            chkPattern = /^(?<year>\d{4})-(?<month>\d{2})-(?<day>\d{2})$/;
            if(chkPattern.test(inputValue)){
                let tmpDate = this.getDate(inputValue,chkPattern);
                return new DatePipe("en-US").transform(tmpDate,format);
            }
        }catch(ex){
            console.error("FilterDateTime",ex);
        }
    }

    getDate(inputValue:string,chkPattern:any):Date{
        let matched = chkPattern.exec(inputValue);
        // console.log("FilterDateTime",matched,inputValue);

        if(matched && matched.length > 0 && matched.groups){
            let matchedItem = matched.groups;
            let tmpDate = new Date();
            try{
                if(matchedItem.year && matchedItem.month && matchedItem.day){
                    tmpDate.setFullYear(Number(matchedItem.year),Number(matchedItem.month)-1,Number(matchedItem.day));
                }
            }catch(ex){
                console.error("FilterDateTime",ex);
            }
            try{
                if(matchedItem.hour && matchedItem.minute && matchedItem.second){
                    tmpDate.setHours(Number(matchedItem.hour),Number(matchedItem.minute),Number(matchedItem.second));
                }
            }catch(ex){
                console.error("FilterDateTime",ex);
            }
            // console.log("FilterDateTime",tmpDate.toISOString(),inputValue);
            return tmpDate;
        }else{
            return null;
        }
    }
    
    /*
    function fvmsLeftPadd(n, width) {
        n = n + '';
        return n.length >= width ? n : new Array(width - n.length + 1).join('0') + n;
    }
    
    function fvmsDateFormat(dateSrc,formatString) {
        if(!dateSrc) return " ";
        if(!formatString) {
            formatString = "yyyy-MM-dd hh:mm:ss";
        }
        
        var weekName = ["일요일", "월요일", "화요일", "수요일", "목요일", "금요일", "토요일"];
        
        return formatString.replace(/(yyyy|yy|MM|dd|E|hh|mm|ss|a\/p)/gi, function($1) {
            switch ($1) {
                case "yyyy": return dateSrc.getFullYear();
                case "yy": return fvmsLeftPadd(dateSrc.getFullYear() % 1000,2);
                case "MM": return fvmsLeftPadd(dateSrc.getMonth() + 1,2);
                case "dd": return fvmsLeftPadd(dateSrc.getDate(),2);
                case "E": return weekName[dateSrc.getDay()];
                case "HH": return fvmsLeftPadd(dateSrc.getHours(),2);
                case "hh": return fvmsLeftPadd( ( (h = dateSrc.getHours() % 12) ? h : 12),2);
                case "mm": return fvmsLeftPadd(dateSrc.getMinutes(),2);
                case "ss": return fvmsLeftPadd(dateSrc.getSeconds(),2);
                case "a/p": return dateSrc.getHours() < 12 ? "오전" : "오후";
                default: return $1;
            }
        });
    };
    */
}
